<template>
  <div>
    <headerBox :current="3"></headerBox>
    <bannerBox ref="bannerChild"></bannerBox>
    <div v-if="isPC" class="en_pc">
      <div class="content_box">
        <left-tabs
          ref="tabsChild"
          :bgColor="1"
          :menu="menuList"
          @change="getMenu"
        ></left-tabs>
        <div class="right_box">
          <item1
            v-if="current == 0"
            :catid="catid"
            :locationList="locationList"
          ></item1>
          <cq-xg
            v-if="current == 1"
            :catid="catid"
            :locationList="locationList"
            @toGG="toGG"
          ></cq-xg>
          <item3
            v-if="current == 2"
            :catid="catid"
            :locationList="locationList"
            @toGG="toGG"
          ></item3>
          <!--          <item2 v-if="current==2" :locationList="locationList"></item2>-->
          <!--          <item4 v-if="current==2" :locationList="locationList"></item4>-->
          <zbhxr
            v-if="current == 3"
            :catid="catid"
            :locationList="locationList"
          ></zbhxr>
          <zsgg
            v-if="current == 4"
            :catid="catid"
            :locationList="locationList"
          ></zsgg>
        </div>
      </div>
    </div>
    <div v-if="!isPC" class="en_sj">
      <div class="tab_box">
        <div
          v-for="(it, i) in menuList"
          :key="i"
          :class="{ selected: current == i }"
          class="tab_item"
          @click="chooseTab(i)"
        >
          <div>{{ it.title }}</div>
          <div v-show="current == i" class="line"></div>
        </div>
      </div>
      <div style="overflow-x: scroll">
        <div style="min-width: 570px; padding: 20px 10px 50px">
          <!-- <van-tabs v-model="current" :swipe-threshold="2" color="#2D85E2" @click="getMenu">
            <van-tab v-for="(it,i) in menuList" :title="it.title"> -->
          <div style="margin-top: 10px">
            <!--            <item1 v-if="current==0"></item1>-->
            <!--            <item3 v-if="current==1" :locationList="locationList"></item3>-->
            <!--            <item2 v-if="current==2" :locationList="locationList"></item2>-->
            <!--            <item4 v-if="current==3" :locationList="locationList"></item4>-->
            <item1
              v-if="current == 0"
              :catid="catid"
              :locationList="locationList"
            ></item1>
            <cq-xg
              v-if="current == 1"
              :catid="catid"
              :locationList="locationList"
              @toGG="toGG"
            ></cq-xg>
            <item3
              v-if="current == 2"
              :catid="catid"
              :locationList="locationList"
              @toGG="toGG"
            ></item3>
            <!--          <item2 v-if="current==2" :locationList="locationList"></item2>-->
            <!--          <item4 v-if="current==2" :locationList="locationList"></item4>-->
            <zbhxr
              v-if="current == 3"
              :catid="catid"
              :locationList="locationList"
            ></zbhxr>
            <zsgg
              v-if="current == 4"
              :catid="catid"
              :locationList="locationList"
            ></zsgg>
          </div>
          <!-- </van-tab>
          </van-tabs> -->
        </div>
      </div>
    </div>
    <footerBox></footerBox>
    <Back-top :bottom="120" :height="100">
      <div class="iconfont icon-shangjiantou"></div>
    </Back-top>
  </div>
</template>

<script>
import bannerBox from "@/components/banner.vue";
import headerBox from "@/components/header.vue";
import footerBox from "@/components/footer.vue";
import leftTabs from "@/components/left_tabs.vue";
import item1 from "./components/item1.vue";
import item2 from "./components/item2.vue";
import item3 from "./components/item3.vue";
import item4 from "./components/item4.vue";
import CqXg from "@/views/engineering/components/CqXg.vue";
import Zbhxr from "@/views/engineering/components/Zbhxr.vue";
import Zsgg from "@/views/engineering/components/Zsgg.vue";
import { getArticle } from "@/api/home/index";

export default {
  name: "home",
  components: {
    bannerBox,
    headerBox,
    footerBox,
    leftTabs,
    item1,
    item2,
    item3,
    item4,
    CqXg,
    Zbhxr,
    Zsgg,
  },
  data() {
    return {
      locationList: [],
      current: 0,
      menuList: [
        {
          title: "招标公告",
          catid: 302,
        },
        {
          title: "澄清与修改公告",
          catid: 304,
        },

        {
          title: "中标结果公示",
          catid: 303,
        },
        {
          title: "中标候选人公示",
          catid: 322,
        },

        {
          title: "资审公告",
          catid: 323,
        },
        // {
        // 	title: '违法违规信息',
        // },
      ],
      isPC: !window.matchMedia("(max-width: 800px)").matches,
      catid: null,
    };
  },
  mounted() {
    const savedPage = sessionStorage.getItem("newsPage");
    let index = "";
    if (savedPage) {
      // 判断是否有缓存分页
      index = this.menuList.findIndex(
        (v) => v.catid == decodeURIComponent(JSON.parse(savedPage).catid),
      );
    } else {
      index = this.menuList.findIndex(
        (v) => v.title == decodeURIComponent(this.$route.query.name),
      );
    }
    this.setLocation(index);
  },
  methods: {
    getMenu(e) {
      sessionStorage.clear("newsPage");
      this.setLocation(e);
    },
    chooseTab(i) {
      this.current = i;
      sessionStorage.clear("newsPage");
      this.setLocation(i);
    },
    setLocation(index) {
      let current =
        index || index == 0 ? index : this.$refs["tabsChild"].current;
      this.current = current;
      let locationList = ["工程交易", this.menuList[current].title];
      this.locationList = locationList;
      this.$refs["tabsChild"].current = current;
      this.$refs["bannerChild"].locationList = locationList;
      this.$nextTick(() => {
        this.catid = this.menuList[index].catid;
      });
    },
    toGG() {
      this.$refs["tabsChild"].current = 0;
      this.setLocation();
    },
  },
};
</script>

<style lang="scss" scoped>
.content_box {
  margin: 80px 100px;
  display: flex;
  min-width: 1200px;

  .right_box {
    min-width: 75%;
  }
}

// 大屏幕
@media only screen and (min-width: 800px) {
  .en_pc {
    display: flex;
  }

  .en_sj {
    display: none;
  }
}

/* 手机 */
@media only screen and (max-width: 800px) {
  .en_pc {
    display: none !important;
  }

  .en_sj {
    display: flex !important;
    flex-direction: column;

    .tab_box {
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      margin-top: 20px;
      font-size: 17px;
      color: #646566;

      .selected {
        color: #323233;
        position: relative;
        font-weight: 500;
      }

      .tab_item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .line {
        width: 40px;
        height: 3px;
        border-radius: 3px;
        background-color: rgb(45, 133, 226);
      }
    }
  }
}
</style>
